export default __webpack_public_path__ + "static/Privacy-Notice_EGTB_EN-0e61d58b59214223d9a716b65fb72807.pdf";